import React from 'react';
import Dialog from '../../Dialog/Dialog';
import Button from '../../Button/Button';

/**
 * Themed confirm dialog for FormDrawer discard / destructive actions.
 */
export default function FormConfirmDialog({
  open,
  onCancel,
  onConfirm,
  title = 'Discard changes?',
  message = 'You have unsaved changes. Close without saving?',
  cancelLabel = 'Keep editing',
  confirmLabel = 'Discard changes',
  confirmLoading = false,
}) {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      title={title}
      maxWidth="xs"
      showCloseButton={false}
      actions={
        <>
          <Button type="button" variant="secondary" onClick={onConfirm} disabled={confirmLoading}>
            {confirmLabel}
          </Button>
          <Button type="button" variant="primary" onClick={onCancel} disabled={confirmLoading}>
            {cancelLabel}
          </Button>
        </>
      }
    >
      {message}
    </Dialog>
  );
}
